import React, { createContext, useContext, useState, useEffect, Fragment } from 'react';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import $ from 'jquery';

function checkRider() {
  let riderNumber = document.getElementById("riderNumber").value;
  document.getElementById("riderBtn").innerHTML = "loading...";

  let data = {
    number: riderNumber,
  };

  let settings = {
    "async": true,
    "crossDomain": true,
    "url": `https://deliveryapi-3765.herokuapp.com/api/users/rider`,
    "method": "GET",
    "headers": {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: `Bearer ${localStorage.getItem("token")}`
    },
    "data": data
  }

  $.ajax(settings).done(function (response) {
    //done
    document.getElementById("riderBtn").innerHTML = "Done";
    document.getElementById("info2").innerHTML = response;
  }).fail(function (xhr, status, error) {
    // error handling
    document.getElementById("riderBtn").innerHTML = "Done";
    document.getElementById("info2").innerHTML = "Sorry, we don't know this number";
  });
}

function Home() {
  useEffect(() => {
    document.getElementById("start").scrollIntoView({ behavior: "smooth", block: "center" });
  });

  return (
    <Fragment>
      <div className="header-05 container container--large header-07__container">
        <div className="header-07__left">
          <div className="header-07__left_content">
            <h1 className="heading heading--accent header-07__heading" id="start">Grab a drink and Relax. let the Riders make offers to you.</h1>
            <p className="header-07__text">Parcels Today is a modern logistics platform made for everyone. Get the riders you need without the commitment.</p>
            <div className="header-07__buttons_box header-07__cta_box">
              <div className="buttons-set">
                <ul className="buttons-set__list">
                  <li className="buttons-set__item"><Link to="/main" className="button   button--accent-bg "
                  >Get Riders</Link>
                  </li>
                  <li className="buttons-set__item">
                    <Link to="/signup" className="button button--accent-outline state-active" type="button">Join the team </Link>
                  </li>
                </ul>
                <div className="score">
                  <div className="score__stars"><img className="score__star" src="img/icons/star--blue.svg" /><img
                    className="score__star" src="img/icons/star--blue.svg" /><img className="score__star"
                      src="img/icons/star--blue.svg" /><img className="score__star" src="img/icons/star--blue.svg" /><img
                      className="score__star" src="img/icons/star--1-4--blue.svg" /></div>
                  <div className="score__text"><span className="score__word">Based on 15+ <br /><a
                    href="https://www.producthunt.com" target="_blank">Product Hunt </a><br />
                    reviews.</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="header-07__right">
          <div className="header-07__img_box"><img className="header-07__img" src="img/other/model.jpg" alt="model" /></div>
        </div>
      </div>

      <div className="cta_button-01">
        <div className="container container--mid">
          <div className="title-box title-box--center">
            <div className="subheading white-text">Quick sign up with Gmail</div>
            <h2 className="heading white-text">Give Parcels Today a Try</h2>
            <p className="title-box__text white-text">Try the Get Rider Platform. Gain access to our vast database of riders to reach relevant
            riders near you and get the lowest prices for your delivery.</p>
          </div>
        </div>
        <div className="container container--small">
          <div className="cta_button-01__button_box">
            <div className="cta_button-01__button_wrapper">
              <div className="cta_button-01__tag"><span className="tag   tag--night"><span className="tag__text">Try it today</span></span>
              </div><Link to="/main" className="button button--large  button--alt-accent-bg "><span>Get a Rider</span></Link>
            </div>
          </div>
        </div>
      </div>

      <div className="posts-02">
        <div className="container container--mid">
          <div className="posts-02__wrapper">
            <div className="posts-02__item posts-02__item--accent">
              <div className="posts-02__text">
                <h3 className="posts-02__title">The Deal of a lifetime</h3>
                <div className="posts-02__info">We set out to find the best riders around the nation and now we present them to you.</div><Link className="feature__link"
                  to="/main"><span style={{ color: "#E00467" }}>Get Started</span><span className="icon"><svg
                    viewBox="0 0 13 10" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M12.823 4.164L8.954.182a.592.592 0 0 0-.854 0 .635.635 0 0 0 0 .88l2.836 2.92H.604A.614.614 0 0 0 0 4.604c0 .344.27.622.604.622h10.332L8.1 8.146a.635.635 0 0 0 0 .88.594.594 0 0 0 .854 0l3.869-3.982a.635.635 0 0 0 0-.88z"
                      fillRule="nonzero" fill="#00396B" /></svg></span>
                </Link>
              </div>
              <div className="posts-02__img" style={{ backgroundImage: "url(blog/wp-content/uploads/2018/10/twi-1.html)" }}></div>
            </div>
            <div className="posts-02__item">
              <div className="posts-02__text">
                <h3 className="posts-02__title">We want to serve you better</h3>
                <div className="posts-02__info">At Parcels Today your suggestions are important. We value each of our users and would love to here what our users have to say.</div><a className="feature__link" target="_blank"
                  href="mailto:team@parcelstoday.com"><span style={{ color: "#E00467" }}>Mail Us</span><span className="icon"><svg
                    viewBox="0 0 13 10" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M12.823 4.164L8.954.182a.592.592 0 0 0-.854 0 .635.635 0 0 0 0 .88l2.836 2.92H.604A.614.614 0 0 0 0 4.604c0 .344.27.622.604.622h10.332L8.1 8.146a.635.635 0 0 0 0 .88.594.594 0 0 0 .854 0l3.869-3.982a.635.635 0 0 0 0-.88z"
                      fillRule="nonzero" fill="#00396B" /></svg></span>
                </a>
              </div>
              <div className="posts-02__img" style={{ backgroundImage: "url(img/icons/Del.png )" }}></div>
            </div>
          </div>
        </div>
      </div>

      <div className="pricing-03">
        <div className="pricing-03__container container container--large">
          <div className="pricing-03__wrapper">
            <div className="pricing-03__info">
              <h2 className="heading">Free to Use</h2>
              <div className="pricing-03__info_text">
                <p>Parcels today provides you access to riders across your nation while maintaining a close relationship with both our riders and customers to improve
                our customer service.</p>
                <p>Users unwilling to use the online platform may simply call our office line to make requests.</p>
              </div>
            </div>
            <div className="pricing-03__illustration js-toggle-animation" title="Release sunlight"><img
              className="pricing-03__main_img" src="img/emoji/cloud.png" /><img className="pricing-03__secondary_img"
                src="img/emoji/sun.png" /></div>
            <div className="pricing-03__price">
              <div className="pricing-03__price_top">
                <h2 className="heading">Save over GH¢520 per year</h2>
              </div>
              <div className="pricing-03__price_bottom">
                <ul className="pricing-03__benefits_list">
                  <li className="pricing-03__benefit"><img className="pricing-03__benefit_icon" src="img/icons/checked--acid.svg" />
                    <div className="pricing-03__benefit_text">Dozens of riders</div>
                  </li>
                  <li className="pricing-03__benefit"><img className="pricing-03__benefit_icon" src="img/icons/checked--acid.svg" />
                    <div className="pricing-03__benefit_text">Easy to track</div>
                  </li>
                  <li className="pricing-03__benefit"><img className="pricing-03__benefit_icon" src="img/icons/checked--acid.svg" />
                    <div className="pricing-03__benefit_text">Good bargains</div>
                  </li>
                  <li className="pricing-03__benefit"><img className="pricing-03__benefit_icon" src="img/icons/checked--acid.svg" />
                    <div className="pricing-03__benefit_text">Enjoy free support</div>
                  </li>
                </ul>
                <div className="pricing-03__button"><Link className="button   button--accent-bg " to="/main"><span>Start
                  saving</span></Link>
                </div>
              </div>
            </div>
          </div><img className="pricing-03__decoration" src="img/other/grid.png" />
        </div>
      </div>

      <div className="cta_button-01">
        <div className="container container&#45;&#45;small">
          <div className="title-box title-box&#45;&#45;center">
            <h2 className="heading">What People Say</h2>
            <p className="title-box__text">Parcels Today is already used by near a thousand of logistics enthusiasts.</p>
          </div>
        </div>
        <div className="testimonials-01__container container">
          <div className="slider">
            <ul className="slider__box js-slider" data-slider-config="{&quot;dots&quot;: true, &quot;infinite&quot;: true, &quot;speed&quot;: 300, &quot;fade&quot;: false, &quot;cssEase&quot;: &quot;ease&quot;, &quot;adaptiveHeight&quot;: false, &quot;lazyLoad&quot;: &quot;ondemand&quot;}">
              <li className="slider__item">
                <div className="testimonials-01__item"><img className="testimonials-01__logo" src="img/icons/Del.png" />
                  <p className="testimonials-01__text">"Parcels Today was a life saver for me. My initial delivery service was bleeding me dry."</p>
                  <div className="testimonials-01__author">Matt Koomson<br />Dealer in men's Shoes</div>
                </div>
              </li>
              <li className="slider__item">
                <div className="testimonials-01__item"><img className="testimonials-01__logo" src="img/icons/Del.png" />
                  <p className="testimonials-01__text">"I've used this for a few weeks & am absolutely in awe of it. The team is very friendly and I enjoy having many options. It makes me feel important when riders call to give me offers to carry my goods."</p>
                  <div className="testimonials-01__author">Khalid Fuseini<br />Tech supplier</div>
                </div>
              </li>
              <li className="slider__item">
                <div className="testimonials-01__item"><img className="testimonials-01__logo" src="img/icons/Del.png" />
                  <p className="testimonials-01__text">"This is a good one.
                  Sincerely, I really like the fact that I can switch my riders any time I wish without being pressured to stick to one service."</p>
                  <div className="testimonials-01__author">James Otoo</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="cta_form-04">
        <div className="container container--mid">
          <div className="cta_form-04__wrapper">
            <div className="cta_form-04__top">
              <div className="cta_form-04__heading_box">
                <h2 className="heading cta_form-04__heading">Rider Checker</h2>
              </div>
              <div className="cta_form-04__form_box">

                <form className="form js-subscribe-mailchimp-form">
                  <div className="form__inputs">
                    <div className="form__input">
                      <input id="riderNumber" maxLength="10" className="text-input js-email-input" type="number" name="number" placeholder="Enter rider's phone number" />
                    </div>
                    <div className="form__button">
                      <button className="button js-submit-button button--black-bg" id="riderBtn" type="button" onClick={checkRider} ><span
                        className="button__text">Check</span>
                        <div className="spinner"></div>
                        <div className="button__submit_success">
                          <div className="button__success_circle"></div>
                          <div><svg className="button__success_tick" width="13" height="13" viewBox="0 0 13 13"
                            xmlns="http://www.w3.org/2000/svg">
                            <path className="button__success_tick_path" stroke="#FFF" d="M0 8l5.119 3.873L11.709.381"
                              fill="none" fillRule="evenodd" strokeLinecap="square" /></svg></div>
                        </div><span className="icon"><svg viewBox="0 0 13 10" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M12.823 4.164L8.954.182a.592.592 0 0 0-.854 0 .635.635 0 0 0 0 .88l2.836 2.92H.604A.614.614 0 0 0 0 4.604c0 .344.27.622.604.622h10.332L8.1 8.146a.635.635 0 0 0 0 .88.594.594 0 0 0 .854 0l3.869-3.982a.635.635 0 0 0 0-.88z"
                            fillRule="nonzero" fill="#00396B" /></svg></span>

                      </button>
                      <p id="info2"></p>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment >
  )
}

export default Home;